import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';

export function BlogCard () {
  return (
      <Card>
        <CardMedia
          component="img"
          height="200"
          image="/img/blog.png"
          alt="blog"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Blog
          </Typography>
          <Typography>Programming, birds, etc...</Typography>
        </CardContent>
        <CardActions>
          <Button onClick={() => window.location.href = 'https://blog.taylordeckard.me'}>View</Button>
        </CardActions>
      </Card>
  )
}
